import { ArrowUpRight, Instagram, ShoppingBag, Tag } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";
import { STORE_URL, INSTAGRAM_URL, VINTED_URL } from "../../data/catalog";

const channels = [
  { k: "instagram", name: "Instagram", handle: "@Instant_TCGz", url: INSTAGRAM_URL, Icon: Instagram, ring: "hover:border-pink-400" },
  { k: "ebay", name: "eBay", handle: "Instant_TCGz", url: STORE_URL, Icon: ShoppingBag, ring: "hover:border-cyanx" },
  { k: "vinted", name: "Vinted", handle: "Instant_TCGz", url: VINTED_URL, Icon: Tag, ring: "hover:border-emerald-400" },
];

const Channel = ({ c }) => {
  const body = (
    <>
      <c.Icon className="h-6 w-6" />
      <div className="flex-1">
        <div className="font-display text-xl font-bold">{c.name}</div>
        <div className="font-mono text-xs uppercase tracking-[0.15em] text-slate-400">{c.handle}</div>
      </div>
      {c.url && <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:rotate-45" />}
    </>
  );
  const cls = `group flex items-center gap-4 rounded-2xl border border-white/10 bg-white/[0.03] px-5 py-4 transition-colors duration-300 ${c.ring}`;
  return c.url
    ? <a href={c.url} target="_blank" rel="noopener noreferrer" className={cls} data-testid={`social-${c.k}`}>{body}</a>
    : <div className={cls} data-testid={`social-${c.k}`}>{body}</div>;
};

export const Socials = () => (
  <section className="mx-auto grid max-w-[1400px] items-center gap-12 px-5 py-24 lg:grid-cols-12 lg:px-10 lg:py-32" data-testid="socials-section">
    <Reveal className="lg:col-span-7">
      <div className="slab-frame overflow-hidden rounded-[28px]">
        <img src="/brand/social.webp" alt="Follow InstantTCGZ on Instagram, eBay and Vinted" className="aspect-[3/2] w-full object-cover" />
      </div>
    </Reveal>
    <Reveal delay={0.1} className="lg:col-span-5">
      <SectionLabel n="05">Collect · Trade · Grow</SectionLabel>
      <h2 className="font-display text-4xl font-black uppercase leading-[0.9] sm:text-5xl">Follow for<br /><span className="text-volt">new stock.</span></h2>
      <p className="mt-5 max-w-md text-base text-slate-300">New arrivals, exclusive deals and updates — find us wherever you collect.</p>
      <div className="mt-8 flex flex-col gap-3">
        {channels.map((c) => <Channel key={c.k} c={c} />)}
      </div>
    </Reveal>
  </section>
);
